import {
  account_info, link_out, loan,
  pay_bills,
  request_payment,
  send_money,
  split_payment,
  top_up,
} from '../../utils/DictionaryManagementUtils';

export const getPathName = (theKey, duplicationNumber) => {
  switch (theKey) {
    case send_money:
      return `sendMoneyPath_${duplicationNumber}`;
    case account_info:
      return `accountInfoPath_${duplicationNumber}`;
    case pay_bills:
      return `payBillsPath_${duplicationNumber}`;
    case top_up:
      return `topUpPath_${duplicationNumber}`;
    case request_payment:
      return `requestPaymentPath_${duplicationNumber}`;
    case split_payment:
      return `splitPaymentPath_${duplicationNumber}`;
    case link_out:
      return '';
    case loan:
      return `loanPath_${duplicationNumber}`;
    default:
      return 'noPath';
  }
};

export const getFlowCode = (service) => {
  const { duplication_number } = service;
  switch (service.sub_category) {
    case send_money:
      return 100 + duplication_number;
    case account_info:
      return 110 + duplication_number;
    case pay_bills:
      return 120 + duplication_number;
    case request_payment:
      return 130 + duplication_number;
    case split_payment:
      return 140 + duplication_number;
    case top_up:
      return 150 + duplication_number;
    case link_out:
      return 170 + duplication_number;
    case loan:
      return 180 + duplication_number;
    default:
      return 0;
  }
};

export const getUserTypesByService = (service, user_types) => {
  const userTypeDescriptionList = [];

  const { userTypes } = user_types;
  userTypes.forEach((user_Type) => {
    if (user_Type.services.includes(service) && !userTypeDescriptionList.includes(service)) {
      userTypeDescriptionList.push(`${user_Type.typeID}`);
    }
  });
  return userTypeDescriptionList;
};
